import script from "./ThemedBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemedBanner.vue?vue&type=script&setup=true&lang=js"

import "./ThemedBanner.vue?vue&type=style&index=0&id=0bc7f0e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc7f0e2"]])

export default __exports__